module.exports = __webpack_public_path__ + "static/media/user.870fd4f7.svg";